import { defineStyleConfig } from "@chakra-ui/react";
import Colors from "../../assets/colors/Colors";

const ButtonTheme = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    fontWeight: "500",
  },
  variants: {
    outline: {
      border: "1px solid",
      borderColor: Colors.grubOutlinebuttonBorderColor,
      color: Colors.taxInfo,
      background: Colors.grubOutlinebuttonColor,
      _hover: {
        background: Colors.grubOutlinebuttonColor,
        borderColor: Colors.grubOutlinebuttonColor,
      },
      _focus: {
        background: Colors.buttonOutlineFocus,
        borderColor: Colors.inputBorderColor,
        boxShadow: "0px 0px 0px 3px" + Colors.taxInfo,
      },
      _press: {
        background: Colors.inputBorderColor,
      },
      _disabled: {
        backgroundColor: Colors.buttonOutlineDisable,
      },
      _focusVisible: {
        background: Colors.navbarLink,
        boxShadow: "0px 0px 0px 3px " + Colors.taxInfo,
      },
    },
    solid: {
      bg: Colors.taxInfo,
      color: Colors.loginAuthBackground,
      _hover: {
        background: Colors.GrubButton,
      },
      _active: {
        background: Colors.GrubButton,
      },
      _disabled: {
        _hover: {
          background: Colors.GrubButton,
        },
      },
      _focusVisible: {
        boxShadow: "none",
      },
    },
    ghost: {
      fontWeight: "500",
      fontSize: "0.75rem",
      lineHeight: "0.94rem",
      // border: "1px solid",
      // borderColor: Colors.modifierTable,
      borderRadius: "0.625rem",
      bg: Colors.ghostBackground,
      color: Colors.posTextInfo,
      _hover: {
        background: Colors.grubOutlinebuttonColor,
      },
    },
    posghost: {
      border: "0.06rem solid #b7b7b733",
      _hover: {
        background: "#E8E9EF !important",
      },
      _active: {
        background: "#E8E9EF !important",
      },
      _disabled: {
        _hover: {
          background: "#E8E9EF !important",
        },
      },
      _focusVisible: {
        boxShadow: "none",
      },
    },
    avatar: {
      color: Colors.posTextInfo,
      borderColor: Colors.posTextInfo,
      border: "1px solid",
      backgroundColor: "transparent",
      _hover: {
        background: Colors.buttonOutlineHover,
      },
    },
    invoerror: {
      color: Colors.posCancleButtonRed,
      borderColor: Colors.posCancleButtonRed,
      border: "1px solid",
      backgroundColor: "transparent",
      _hover: {
        background: Colors.buttonOutlineHover,
      },
    },
    gruboutline: {
      border: "0.5px solid",
      borderRadius: "0.44rem",
      borderColor: Colors.dividerColor,
      color: Colors.posTextInfo,
      alignSelf:"center",
      backgroundColor: Colors.buttonOutlineFocus,
      _hover: {
        background: Colors.buttonOutlineHover,
        borderColor: Colors.buttonOutlineHover,
      },
      _focus: {
        background: Colors.buttonOutlineFocus,
        borderColor: Colors.inputBorderColor,
        // boxShadow: "0px 0px 0px 3px" + Colors.taxCreateExemptEbt,
      },
      _press: {
        background: Colors.inputBorderColor,
      },
      _disabled: {
        backgroundColor: Colors.buttonOutlineDisable,
      },
      _focusVisible: {
        background: Colors.navbarLink,
        boxShadow: "0px 0px 0px 3px " + Colors.taxCreateExemptEbt,
      },
    },
  },
});

export default ButtonTheme;
